import { SET_DISABLED_LENDER_PROFILES } from './types';

const initialState = [];

export const disabledLenderProfilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DISABLED_LENDER_PROFILES:
      return action.payload;
    default:
      return state;
  }
};
